/**
 * The only two countries in our picker that post road distances in miles. Deliberately
 * a two-entry list, not an oversight — everywhere else is metric.
 */
const IMPERIAL_COUNTRIES = new Set(['US', 'GB']);
/**
 * The distance unit a country's drivers expect. Used as a DEFAULT when the user changes
 * country — never to override a unit they picked deliberately.
 */
export function defaultUnitForCountry(country) {
    return IMPERIAL_COUNTRIES.has(country) ? 'imperial' : 'metric';
}
/** The display suffix for a unit system. */
export function unitSuffix(unit) {
    return unit === 'metric' ? 'km' : 'mi';
}
//# sourceMappingURL=units.js.map